<template>
      <div data-v-c9bcc182="" class="loading-more-container">
          <div data-v-c9bcc182="" style="color: rgb(170, 174, 184); font-size: 0.12rem;">
            {{ sportTableLang['SPORT_TABLE.END'] }}
          </div>
      </div>
</template>
<script>
import {
    mapGetters
  } from 'vuex'

  export default {
      computed: {
        ...mapGetters([
          'sportTableLang',
        ]),
      },
      methods: {
        
      },
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/score/vue/apps/core/scrollEnd.vue